import {
  ListGroup,
  Row,
  Tab,
  Container,
  Carousel,
  Col,
  Card,
} from "react-bootstrap";
import coverage from "../assets/img/hamrah_huree.jpg";
import Slider from "react-slick";
import Breadcrumbs from "./Layout/Breadcrumb";
import { useState } from "react";
import h08 from "../assets/img/history/2008.jpg";
import h09 from "../assets/img/history/2009.jpg";
import h10 from "../assets/img/history/2010.jpg";
import h11 from "../assets/img/history/2011.jpg";
import h1114 from "../assets/img/history/2011-2014.jpg";
import h13 from "../assets/img/history/2013.jpg";
import h15 from "../assets/img/history/2015.jpg";
import h16 from "../assets/img/history/2016.jpg";
import h17 from "../assets/img/history/2017.jpg";
import h18 from "../assets/img/history/2018.jpg";
import h19 from "../assets/img/history/2019.jpg";
import h20 from "../assets/img/history/2020.jpg";
import h21 from "../assets/img/history/2021.jpg";
import h22 from "../assets/img/history/2022.png";
import i1 from "../assets/img/goals/1.png";
import i2 from "../assets/img/goals/2.png";
import i3 from "../assets/img/goals/3.png";
import i4 from "../assets/img/goals/4.png";
import f1 from "../assets/img/goals/1-1.png";
import f2 from "../assets/img/goals/2-1.png";
import f3 from "../assets/img/goals/3-1.png";
import f4 from "../assets/img/goals/4-1.png";
import fair from "../assets/img/values/fair.jpg";
import accountability from "../assets/img/values/accountability.jpg";
import creativity from "../assets/img/values/creativity.jpg";
import leadership from "../assets/img/values/leadership.jpg";
import professionalism from "../assets/img/values/professionalism.jpg";
import sustainability from "../assets/img/values/sustainability.jpg";
import teamwork from "../assets/img/values/teamwork.jpg";
import m1 from "../assets/img/management/1.png";
import m2 from "../assets/img/management/2.png";
import m3 from "../assets/img/management/3.png";
import m4 from "../assets/img/management/4.png";
import m5 from "../assets/img/management/5.png";
import m6 from "../assets/img/management/6.png";
import { subUrl } from "../helper/globals";
export default function About() {
  const [title, setTitle] = useState("ABOUT US");
  return (
    <Breadcrumbs
      title={title}
      content={
        <Container className="section-content" fluid>
          <Tab.Container defaultActiveKey="#aboutus">
            <Row className="md-center">
              <ListGroup className="list-group-horizontal-md">
                <ListGroup.Item
                  action
                  href="#aboutus"
                  className="tabs-title tabs"
                  onClick={() => {
                    setTitle("ABOUT US");
                  }}
                >
                  ABOUT US
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  href="#goal"
                  className="tabs-title tabs"
                  onClick={() => {
                    setTitle("MISSION, VALUES");
                  }}
                >
                  MISSION, VALUES
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  href="#management"
                  className="tabs-title tabs"
                  onClick={() => {
                    setTitle("MANAGEMENT TEAM");
                  }}
                >
                  MANAGEMENT TEAM
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  href="#stakeholders"
                  className="tabs-title tabs"
                  onClick={() => {
                    setTitle("SHAREHOLDERS");
                  }}
                >
                  SHAREHOLDERS
                </ListGroup.Item>
                <ListGroup.Item
                  action
                  href="#history"
                  className="tabs-title tabs"
                  onClick={() => {
                    setTitle("OUR HISTORY");
                  }}
                >
                  OUR HISTORY
                </ListGroup.Item>
              </ListGroup>
            </Row>

            <Tab.Content>
              <Tab.Pane eventKey="#aboutus">
                <Row style={{ paddingTop: "20px" }}>
                  <div className="small-12 columns text-justify">
                    <p style={{ textIndent: "50px" }}>
                      The Satellite digital television service provider, “DDish
                      TV” LLC began transmitting 18 television channels by
                      Mongolian countrywide in 2008 and have been a pioneer in
                      its service field, and conducting technological
                      advancements.
                    </p>
                    <Carousel>
                      <Carousel.Item>
                        <img src={f4} />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src={f1} />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src={f2} />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src={f3} />
                      </Carousel.Item>
                    </Carousel>
                    <p style={{ textIndent: "50px" }}>
                      Nowadays, Our company has five main branches for sales and
                      service in Ulaanbaatar city, over sixty contracted dealers
                      in the rural area, twenty-four hours station for control ,
                      and a call centre for caring our customers. We are
                      broadcasting local and foreign TV channels and radio
                      channels in high quality.
                    </p>
                    <h4>Coverage</h4>
                    <img src={coverage} alt="areas served" />
                  </div>
                </Row>
              </Tab.Pane>
            </Tab.Content>
            <Tab.Content>
              <Tab.Pane eventKey="#goal">
                <Row style={{ paddingTop: "20px" }}>
                  <div className="small-12 columns">
                    <Carousel>
                      <Carousel.Item>
                        <img src={i1} />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src={i2} />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src={i3} />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img src={i4} />
                      </Carousel.Item>
                    </Carousel>
                    <p style={{ marginTop: "20px" }}>
                      <h4>Mission:</h4>
                      We are,
                      <br />
                      leaders in distributing content and information
                      <br />
                      which light-up everyone’s minds with high quality, wide
                      ranging and modern solutions.
                      <br />
                    </p>
                    <hr />
                    <Row>
                      <h4>Values</h4>
                      <p style={{ textIndent: "50px" }}>
                        While DDISHTV employees strive to achieve their mission
                        and goals, they prioritize MCS group values and
                        principles.
                      </p>
                    </Row>

                    <Row>
                      <Col>
                        <img src={professionalism} alt="professionalism" />
                      </Col>
                      <Col
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "justify",
                        }}
                      >
                        <h4>MASTERY</h4>
                        Professional competency and dedication to ongoing
                        personal growth
                      </Col>
                    </Row>
                    <hr />

                    <Row style={{ marginTop: "10px" }}>
                      <Col
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "justify",
                        }}
                      >
                        <h4>TEAM SPIRIT</h4>
                        Establish trust and respect to bring about effective
                        collaboration amongst team members
                      </Col>
                      <Col>
                        <img src={teamwork} alt="teamwork" />
                      </Col>
                    </Row>
                    <hr />

                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <img src={leadership} alt="leadership" />
                      </Col>
                      <Col
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "justify",
                        }}
                      >
                        <h4>LEADERSHIP</h4>
                        Identify growth and development opportunities and rally
                        colleagues around new ideas. Inspire and encourage
                        others and work as a team to bring ideas to fruition
                      </Col>
                    </Row>
                    <hr />

                    <Row style={{ marginTop: "10px" }}>
                      <Col
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "justify",
                        }}
                      >
                        <h4>MCS SPIRIT</h4>
                        Commitment and dedication to one’s work and company
                      </Col>
                      <Col>
                        <img src={accountability} alt="accountability" />
                      </Col>
                    </Row>
                    <hr />

                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <img src={creativity} alt="creativity" />
                      </Col>
                      <Col
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "justify",
                        }}
                      >
                        <h4>CREATIVITY</h4>
                        Apply creative solutions to problem solving
                      </Col>
                    </Row>
                    <hr />

                    <Row style={{ marginTop: "10px" }}>
                      <Col
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "justify",
                        }}
                      >
                        <h4>INTEGRITY</h4>
                        Respect and observe all relevant laws and regulations
                        and practice integrity
                      </Col>
                      <Col>
                        <img src={fair} alt="fair" />
                      </Col>
                    </Row>
                    <hr />

                    <Row style={{ marginTop: "10px" }}>
                      <Col>
                        <img src={sustainability} alt="sustainability" />
                      </Col>
                      <Col
                        style={{
                          display: "flex",
                          alignContent: "center",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          textAlign: "justify",
                        }}
                      >
                        <h4>SUSTAINABLE DEVELOPMENT</h4>
                        Prefer to be friendly for our society, nature and
                        environment and consider occupational safety as a
                        priority.
                      </Col>
                    </Row>
                    <hr />

                    <Row style={{ marginTop: "20px" }}>
                      <h4>PRINCIPLES:</h4>
                      <ol>
                        <li>
                          Each employee has a duty to grow professionally and
                          help others do so
                        </li>
                        <li>
                          We are an equal opportunity employer and provide a
                          working environment conducive to professional
                          development. Employees’ performance and quality of
                          work has a direct bearing on their growth within the
                          company
                        </li>
                        <li>
                          We aspire to be not only good employees but also great
                          leaders and role models
                        </li>
                        <li>We encourage creativity and new ideas</li>
                        <li>
                          We provide our customers with the best products and
                          services
                        </li>
                        <li>
                          Our success lies in creating teams with highly skilled
                          members who respect and trust each other and work well
                          together
                        </li>
                        <li>
                          Teamwork and collaboration is essential at every level
                          of the group
                        </li>
                        <li>
                          We take ownership of our work and respect the
                          company’s reputation and property
                        </li>
                        <li>
                          We support and help each other to achieve great
                          results. We do so with integrity. We do the right
                          thing, the right way. We keep our promises, take
                          responsibility and work to earn trust and respect
                        </li>
                        <li>
                          We are a law-abiding corporate citizen. We are honest
                          and fair in our relationships with our employees,
                          partners and customers
                        </li>
                        <li>
                          We prefer to be friendly for our society, nature and
                          environment.
                        </li>
                        <li>We consider occupational safety as a priority.</li>
                      </ol>
                    </Row>
                  </div>
                </Row>
              </Tab.Pane>
            </Tab.Content>
            <Tab.Content>
              <Tab.Pane eventKey="#stakeholders">
                <Row style={{ paddingTop: "20px" }}>
                  <div className="small-12 columns">
                    <p>
                      <ol>
                        <li>Ts.Tserenpuntsag, A citizen of Mongolia /51%/</li>
                        <li>
                          “Orbitnet LLC”, Legal entities of Mongolia /49%/
                        </li>
                      </ol>
                    </p>
                  </div>
                </Row>
              </Tab.Pane>
            </Tab.Content>
            <Tab.Content>
              <Tab.Pane eventKey="#history">
                <Row style={{ paddingTop: "20px" }}>
                  <div className="package">
                    <Slider
                      autoplay="false"
                      dots
                      autoplay-speed="15000"
                      infinite="true"
                      className="ajil history"
                    >
                      <div>
                        <div className="medium-5 columns">
                          <img src={h08} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2008</div>
                              <ul className="check">
                                <li>
                                  Began transmitting 18 channels of television
                                  in DVB-S standard with 4.5 m diameter antenna.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns ">
                          <img src={h09} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2009</div>
                              <ul className="check">
                                <li>
                                  Started to use 9.3m diameter antenna system.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h10} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2010</div>
                              <ul className="check">
                                <li>
                                  Extended interconnection centre of MNB and
                                  began transmitting 3 channels of radio.
                                </li>
                                <li>
                                  Opened the sales branch in ‘Hurs’ shopping
                                  centre.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h11} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2011</div>
                              <ul className="check">
                                <li>
                                  Had made extension of DVB-S2 standard digital
                                  television system and began transmitting 60+
                                  television channel and 5 more radio channel.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h1114} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2011 - 2014</div>
                              <ul className="check">
                                <li>
                                  Installed transmitting station of digital
                                  television at 220 soums and villages in frame
                                  of the project of digital television by the
                                  government.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h13} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2013</div>
                              <ul className="check">
                                <li>
                                  Implemented 11m diameter antenna system.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h15} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2015</div>
                              <ul className="check">
                                <li>
                                  Began transmitting 90 digital television
                                  channel (3 packages) and 5 radio channels.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h16} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2016</div>
                              <ul className="check">
                                <li>
                                  Enhanced types of product and service, and
                                  provided ENGIIN, ILUU and ULEMJ packages to
                                  the service.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="medium-5 columns">
                          <img src={h17} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2017</div>
                              <ul className="check">
                                <li>
                                  Migrated to a new satellite, and began
                                  broadcasting higher quality and stronger
                                  signals, more HD channels and movie channels,
                                  with more choices to customers.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h18} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2018</div>
                              <ul className="check">
                                <li>
                                  All customers were successfully migrated to
                                  the new satellite station.
                                </li>
                                <li>
                                  Introduction of travel automatic antennas.
                                </li>
                                <li>
                                  Introduction of a new set-top box, enabling
                                  customers to access video-on-demand content
                                  and movies at any given time.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h19} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2019</div>
                              <ul className="check">
                                <li>
                                  KONKA /998,881/ set-top box has become capable
                                  of video-on-demand service
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h20} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2020</div>
                              <ul className="check">
                                <li>Joined the loyalty program “Upoint”</li>
                                <li>
                                  Introduced a new subscription bundle "Ger
                                  Duuren", a tv and internet dual service that
                                  became possible by cooperating with Unitel’s
                                  “Ger” internet service.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h21} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2021</div>
                              <ul className="check">
                                <li>
                                  In the framework of social responsibility,
                                  investments have been made to “Zurkh
                                  martakhgui” and “Id Shidiin Oron” projects
                                  under the motto “Let’s light up the Future”.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="medium-5 columns">
                          <img src={h22} />
                        </div>
                        <div className="medium-7 columns">
                          <div className="timeline">
                            <div className="timeline-content">
                              <div className="year">2022</div>
                              <ul className="check">
                                <li>
                                  With the initiation of “Tariy, Urguulay,
                                  Uramshuulay" campaign, DDISHTV customers
                                  planted 20,000 trees throughout Mongolia.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Slider>
                  </div>
                </Row>
              </Tab.Pane>
            </Tab.Content>

            <Tab.Content>
              <Tab.Pane eventKey="#management">
                <Row style={{ paddingTop: "20px" }}>
                  <div className="small-12 columns">
                    <Row xs={1} md={3}>
                      <Col>
                        <Card style={{ border: "none" }}>
                          <Card.Img src={m1} />
                          <Card.Body>
                            <b>G.Bars</b>
                            <br />
                            CEO
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col>
                        <Card style={{ border: "none" }}>
                          <Card.Img src={m2} />
                          <Card.Body>
                            <b>Ts.Purevdorj</b>
                            <br />
                            VP, Business Development and Sales
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col>
                        <Card style={{ border: "none" }}>
                          <Card.Img src={m3} />
                          <Card.Body>
                            <b>N.Ariunbold</b>
                            <br />
                            CTO
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col>
                        <Card style={{ border: "none" }}>
                          <Card.Img src={m4} />
                          <Card.Body>
                            <b>G.Batmunkh</b>
                            <br />
                            CSO
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col>
                        <Card style={{ border: "none" }}>
                          <Card.Img src={m5} />
                          <Card.Body>
                            <b>B.Enkhbat</b>
                            <br /> General Accountant
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col>
                        <Card style={{ border: "none" }}>
                          <Card.Img src={m6} />
                          <Card.Body>
                            <b>B.Margad-Erdene</b>
                            <br />
                            Manager of ADHR Department
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </Row>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Container>
      }
      route={[{ url: subUrl + "about", text: "About us" }]}
    />
  );
}
